export default "__VITE_ASSET__g_eogfyv__"